/**
 * BUSINESS LOGIC: KISS CAM OVERLAY
 */
import { 
    GetKissConfig as DLGetKissConfig,
    SetKissConfig as DLSetKissConfig,
    ShowKissOverlay as DLShowKissOverlay,
    HideKissOverlay as DLHideKissOverlay,
    TriggerKissAction as DLTriggerKissAction
} from './../DL/Kiss'

export const GetKissConfig = async () => {
    return await DLGetKissConfig();
};

export const SetKissConfig = async (config) => {
    // Validar rangos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.borderWidth < 1) config.borderWidth = 1;
    if (config.frameZoom < 20) config.frameZoom = 20;
    if (config.frameZoom > 100) config.frameZoom = 100;
    if (config.shapeOpacity < 0) config.shapeOpacity = 0;
    if (config.shapeOpacity > 1) config.shapeOpacity = 1;

    return await DLSetKissConfig(config);
};

export const ShowKissOverlay = async () => {
    return await DLShowKissOverlay();
};

export const HideKissOverlay = async () => {
    return await DLHideKissOverlay();
};

export const TriggerKissAction = async (name, state = false) => {
    return await DLTriggerKissAction(name, state);
};
